module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "periodoAberturaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "periodoAberturaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Estou ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "leiModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "leiModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "Estou ciente",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "salvaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "salvaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.limpaModal()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "vazado-verde",
      "rotulo": "Rascunho",
      "icone": "fa-pencil-square-o fa-lg"
    },
    on: {
      "clicado": function($event) {
        return _vm.salva(_vm.declaracaoModal, 'PENDENTE')
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Entregar",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.salva(_vm.declaracaoModal, 'FINALIZADA')
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "modal"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "retificaModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "retificaModalLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal",
      "dismiss": "modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.limpaModal()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Retificar",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.salvaRetificada(_vm.declaracaoModal)
      }
    }
  })], 1)])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "role": "side-modal"
    }
  }, [_c('side-modal', {
    attrs: {
      "sides": _vm.navs
    }
  }, [_c('template', {
    slot: _vm.navs[0].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', [_c('strong', [_vm._v("Eu declaro...")]), _vm._v(" "), _c('esconde-div', [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                      Declaro, sob as penas da lei, que as informações aqui\n                      prestadas são verdadeiras, autorizando a Administração a\n                      proceder, por meio eletrônico, à guarda das informações\n                      constantes neste formulário, bem como das informações\n                      posteriores que atualizarão a presente, resguardado o\n                      sigilo destas. Em conformidade com o disposto nos\n                      artigos 57 e 63, da Lei Orgânica do Município, com a\n                      alteração dada pela Emenda nº 09 de 22/11/92, declaro\n                      possuir na presente data os seguintes bens:\n                    ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [(
    _vm.declaracaoModal.situacao == 'RETIFICADA' ||
    _vm.declaracaoModal.situacao == 'FINALIZADA'
  ) ? _c('p', [_c('strong', [_vm._v("Entregue em")]), _vm._v("\n                  " + _vm._s(_vm._f("formataData")(_vm.declaracaoModal.dataDeclaracao)) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.declaracaoModal.situacao == 'RETIFICADORA') ? _c('p', [_c('strong', [_vm._v("Retificada em")]), _vm._v("\n                  " + _vm._s(_vm._f("formataData")(_vm.declaracaoModal.dataDeclaracao)) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', [(_vm.carregandoItens) ? _c('div', [_c('h2', {
    staticClass: "carregando"
  }, [_vm._v("Carregando...")])]) : _c('div', [(_vm.declaracaoModal.semBens) ? _c('div', {
    staticClass: "alert alert-success",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-check fa-lg"
  }), _vm._v(" \n                  "), _c('strong', [_vm._v("Você declarou não possuir bens nos termos da legislação\n                    vigente.")])]) : (!_vm.declaracaoModal.itens.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer"
    },
    attrs: {
      "role": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.novoItem()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você ainda não tem\n                  bens declarados.\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraCopiaAnteriorNoSideModal()),
      expression: "mostraCopiaAnteriorNoSideModal()"
    }]
  }, [_c('br')]), _vm._v("\n                  Para começar, clique em NOVO.\n                  "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraCopiaAnteriorNoSideModal()),
      expression: "mostraCopiaAnteriorNoSideModal()"
    }]
  }, [_vm._v("\n                    Ou importe dados clicando em DECLARAÇÃO ANTERIOR.\n                  ")])]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Tipo")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    class: _vm.declaracaoModal.situacao == 'EM_BRANCO' ?
      'hidden-xs' :
      ''
  }, [_vm._v("\n                        Valor\n                      ")]), _vm._v(" "), (
    _vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)
  ) ? _c('th', [_vm._v("\n                         \n                      ")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.declaracaoModal.itens), function(item) {
    return _c('tr', {
      key: _vm.declaracaoModal.itens.indexOf(item)
    }, [_c('td', [_vm._v(_vm._s(item.tipo.descricao.toUpperCase()))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                        " + _vm._s(item.descricao.toUpperCase()) + "\n                      ")]), _vm._v(" "), _c('td', {
      class: _vm.declaracaoModal.situacao == 'EM_BRANCO' ?
        'hidden-xs' :
        ''
    }, [_vm._v("\n                        " + _vm._s(_vm._f("monetarioMask")(item.valor)) + "\n                      ")]), _vm._v(" "), (
      _vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)
    ) ? _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "exclui-tabela",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.apagaItem(item)
        }
      }
    }), _vm._v(" "), _c('botao', {
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.editaItem(item)
        }
      }
    })], 1) : _vm._e()])
  }), 0)]), _vm._v(" "), (_vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)) ? _c('div', {
    staticClass: "col-xs-12 footer-controller-inner-modal"
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "Novo",
      "icone": "novo-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.novoItem()
      }
    }
  }), _vm._v(" "), (
    !_vm.declaracaoModal.itens.length &&
    !_vm.declaracaoModal.semBens
  ) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": _vm.telaEhBigMobile ? 'S/ bens' : 'Sem bens',
      "icone": "cancela-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.semBensModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mostraCopiaAnteriorNoSideModal()) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": _vm.telaEhBigMobile ? 'Decl. Ant.' : 'Declaração Anterior',
      "icone": "fa-magic",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.copiaDeclaracaoAnterior()
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mostraJustificativaNoSideModal(_vm.declaracaoModal)) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("\n                    Observação ou justificativa (não obrigatório)\n                  ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.declaracaoModal.justificativa),
      expression: "declaracaoModal.justificativa"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa",
      "id": "justificativa",
      "rows": "4",
      "readonly": !_vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal),
      "maxlength": "500"
    },
    domProps: {
      "value": (_vm.declaracaoModal.justificativa)
    },
    on: {
      "keyup": function($event) {
        return _vm.charCount()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.declaracaoModal, "justificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.totalCharacter) + "/500")]), _vm._v(" "), (_vm.totalCharacter == 500) ? _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "characterAlert"
  }, [_vm._v("A justificativa deve conter no máximo 500\n                      caracteres.")])]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancela()
      }
    }
  }), _vm._v(" "), (_vm.mostraBotoesDeEdicaoNoSideModal(_vm.declaracaoModal)) ? _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "icone": "ok-modal",
      "rotulo": _vm.declaracaoModal.situacao == 'RETIFICANTE' ?
        'Retificar' :
        'Salvar'
    },
    on: {
      "clicado": function($event) {
        _vm.declaracaoModal.situacao == 'RETIFICANTE' ?
          _vm.abreEnviaModal(_vm.declaracaoModal, '#retificaModal') :
          _vm.abreEnviaModal(_vm.declaracaoModal, '#salvaModal')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.declaracaoModal.id),
      expression: "declaracaoModal.id"
    }],
    attrs: {
      "estilo": _vm.declaracaoModal.situacao == 'RETIFICADA' ||
        _vm.declaracaoModal.situacao == 'FINALIZADA' ||
        _vm.declaracaoModal.situacao == 'RETIFICADORA' ?
        'cheio-verde' :
        'vazado-verde',
      "rotulo": "Imprimir",
      "icone": "fa-print fa-lg",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.imprime(_vm.declaracaoModal.id)
      }
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: _vm.navs[1].identidade
  }, [_c('div', {
    staticClass: "side-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', [_c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Tipo de Bem",
      "field": "tipoBem",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.tipo),
      expression: "itemModal.tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipoBem",
      "data-vv-as": "Tipo de Bem"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.itemModal, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "selected"
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.tiposBens), function(tipo) {
    return _c('option', {
      key: _vm.tiposBens.indexOf(tipo),
      domProps: {
        "value": tipo
      }
    }, [_vm._v("\n                      " + _vm._s(((tipo.descricao) + " (cód. IR - " + (tipo.codigo) + ")")) + "\n                    ")])
  })], 2)]), _vm._v(" "), _c('field-validation', {
    attrs: {
      "css-class": "col-md-6 col-sm-6",
      "label": "Valor",
      "field": "valor",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        is_not: 0
      }),
      expression: "{ is_not: 0 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "valor",
      "id": "valor",
      "data-vv-as": "Valor"
    },
    model: {
      value: (_vm.itemModal.valor),
      callback: function($$v) {
        _vm.$set(_vm.itemModal, "valor", $$v)
      },
      expression: "itemModal.valor"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "heranca"
    }
  }, [_vm._v("Herança")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.heranca),
      expression: "itemModal.heranca"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "heranca",
      "name": "heranca"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.itemModal, "heranca", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "true"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("SIM")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("NÃO")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Parceiro Econômico")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.dependencia),
      expression: "itemModal.dependencia"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "dependente"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.itemModal, "dependencia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.incluiDependente(_vm.itemModal)
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "true"
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Escolha")]), _vm._v(" "), _vm._l((_vm.dependencias), function(dependencia) {
    return _c('option', {
      key: dependencia.id,
      domProps: {
        "value": dependencia
      }
    }, [_vm._v("\n                        " + _vm._s(dependencia.dependente.nome) + "\n                      ")])
  })], 2)])])]), _vm._v(" "), (_vm.mostraAtualizarRenda) ? _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Renda Anual do Parceiro",
      "field": "rendaAnual",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        is_not: 0
      }),
      expression: "{ is_not: 0 }"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "rendaAnual",
      "id": "rendaAnual",
      "data-vv-as": "Renda Anual"
    },
    model: {
      value: (_vm.rendaAnualDependenteModal),
      callback: function($$v) {
        _vm.rendaAnualDependenteModal = $$v
      },
      expression: "rendaAnualDependenteModal"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row row-field"
  }, [_c('field-validation', {
    attrs: {
      "css-class": "col-md-12 col-sm-12",
      "label": "Descrição",
      "field": "descricao",
      "status": _vm.errors,
      "custom-errors": _vm.apiErrors,
      "show-icon": false
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.itemModal.descricao),
      expression: "itemModal.descricao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4",
      "name": "descricao",
      "id": "descricao",
      "data-vv-as": "Descrição"
    },
    domProps: {
      "value": (_vm.itemModal.descricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.itemModal, "descricao", $event.target.value)
      }
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "side-footer"
  }, [_c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-cinza",
      "rotulo": "Cancelar",
      "icone": "cancela-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.cancelaItem()
      }
    }
  }), _vm._v(" "), _c('botao', {
    attrs: {
      "tipo": "button",
      "estilo": "cheio-verde",
      "rotulo": "Incluir",
      "icone": "ok-modal"
    },
    on: {
      "clicado": function($event) {
        return _vm.validaItem()
      }
    }
  })], 1)])], 2)], 1), _vm._v(" "), _c('section', {
    attrs: {
      "role": "table"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v("\n                Declaração de Bens \n                "), _c('small', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.abreLeiModal()
      }
    }
  }, [_vm._v("(Por que devo declarar meus bens?)")])])]), _vm._v(" "), _c('div', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.declaracoes.length == 0) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center",
      "cursor": "pointer"
    },
    attrs: {
      "role": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.novo(_vm.declaracao)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você ainda não\n                    tem declarações de bens.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ano Base")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Data da Declaração")]), _vm._v(" "), _c('th', [_vm._v("Situação")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.declaracoesOrdenadasDistintas), function(declaracaoItem) {
    return _c('tr', {
      key: declaracaoItem.competencia &&
        declaracaoItem.competencia.ano +
        declaracaoItem.competencia.mes +
        declaracaoItem.dataDeclaracao +
        declaracaoItem.situacao,
      class: declaracaoItem.situacao == 'EM_BRANCO' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_vm._v("\n                          " + _vm._s(_vm.obtemAnoBase(declaracaoItem.competencia)) + "\n                        ")]), _vm._v(" "), (declaracaoItem.dataDeclaracao) ? _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("formataData")(declaracaoItem.dataDeclaracao)) + "\n                        ")]) : _c('td', {
      staticClass: "hidden-xs"
    }, [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.obtemSituacao(declaracaoItem.situacao)))]), _vm._v(" "), _c('td', {
      staticClass: "td-btns"
    }, [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraNova(declaracaoItem)),
        expression: "mostraNova(declaracaoItem)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Declarar'),
        expression: "'Declarar'",
        modifiers: {
          "left": true
        }
      }],
      staticStyle: {
        "width": "83px"
      },
      attrs: {
        "estilo": "vazado-laranja-sm",
        "icone": declaracaoItem.situacao == 'PENDENTE' ?
          'editar-tabela' :
          'fa-file-o fa-lg',
        "toggle": "",
        "target": "",
        "disabled": _vm.desabilitaEdicaoDasAtrasadas(declaracaoItem)
      },
      on: {
        "clicado": function($event) {
          return _vm.novo(declaracaoItem)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraEditar(declaracaoItem)),
        expression: "mostraEditar(declaracaoItem)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "right": true
        }
      }],
      staticStyle: {
        "width": "83px"
      },
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "editar-tabela",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem)
        }
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraRetificarVer(declaracaoItem)),
        expression: "mostraRetificarVer(declaracaoItem)"
      }]
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Retificar'),
        expression: "'Retificar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "fa-wrench fa-lg",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem, 'RETIFICANTE')
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem)
        }
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraVisualizar(declaracaoItem)),
        expression: "mostraVisualizar(declaracaoItem)"
      }]
    }, [_c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Decl.Original'),
        expression: "'Decl.Original'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "fa-history fa-lg",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.visualizaOriginal(declaracaoItem)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.right",
        value: ('Retificada'),
        expression: "'Retificada'",
        modifiers: {
          "right": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar",
        "toggle": "",
        "target": ""
      },
      on: {
        "clicado": function($event) {
          return _vm.edita(declaracaoItem)
        }
      }
    })], 1)], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Declarar",
      "icone": "fa-file-o",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.novo(_vm.declaracao)
      }
    }
  }), _vm._v(" "), (
    _vm.declaracoesOrdenadasDistintas[0].situacao ==
    'EM_BRANCO'
  ) ? _c('botao', {
    attrs: {
      "estilo": "vazado-verde-dir",
      "rotulo": "Sem bens",
      "icone": "cancela-modal",
      "toggle": "",
      "target": ""
    },
    on: {
      "clicado": function($event) {
        return _vm.semBens(_vm.declaracao)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/faq"
    }
  }, [_c('botao', {
    attrs: {
      "estilo": "vazado-laranja-esq",
      "rotulo": _vm.telaEhBigMobile ? '' : 'Faq',
      "icone": "fa fa-question-circle-o fa-lg"
    }
  })], 1)], 1)])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "periodoAberturaModalLabel"
    }
  }, [_vm._v("\n              Período de entrega da Declaração\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "font-size": "1.6rem"
    }
  }, [_c('strong', [_vm._v(" Atenção ")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  O período para a entrega da Declaração de Bens via Central\n                  do Servidor se encerrou. Aguarde um novo período ou envie um\n                  email para\n                  "), _c('strong', [_vm._v("declaracaodebens@santos.sp.gov.br")]), _vm._v(" para\n                  esclarecer suas dúvidas.\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "leiModalLabel"
    }
  }, [_vm._v("\n              Declarações de Bens e Valores Anteriores\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Após 30 (trinta) dias, contados da data limite fixada pela\n                  Secretaria da Receita Federal do Ministério da Fazenda,\n                  todos os servidores municipais no exercício de mandatos,\n                  cargos, funções ou empregos em órgãos da administração\n                  direta e indireta devem efetuar a Declaração Anual de Bens e\n                  Valores, prevista no Decreto Municipal nº 7.517/2016. O\n                  informe é feito exclusivamente por meio do sistema\n                  eletrônico, disponibilizado no site da Prefeitura através da\n                  Secretaria de Finanças e Gestão. Todos os bens e valores de propriedade\n                  do servidor (imóveis, móveis, dinheiro, títulos, ações,\n                  investimentos financeiros, participações societárias e\n                  qualquer outra espécie de bens e valores patrimoniais\n                  existentes no país ou no exterior) devem ser informados.\n                  Também fazem parte da declaração, bens e valores\n                  relacionados ao cônjuge ou companheiro (a), aos filhos ou a\n                  outras pessoas que tenham dependência econômica do\n                  declarante.\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("\n                    Atenção: o servidor que não entregar o documento no prazo\n                    previsto tem a sua remuneração suspensa e está sujeito a\n                    outras medidas administrativas.\n                  ")])]), _vm._v(" "), _c('p', [_vm._v("\n                  Lembrando que aposentados e pensionistas estão isentos da\n                  Declaração Anual de Bens e Valores.\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "salvaModalLabel"
    }
  }, [_vm._v("\n              Entregar Declaraçao\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                  Deseja\n                  "), _c('strong', [_vm._v("entregar")]), _vm._v(" sua declaração agora ou prefere\n                  apenas salvar um "), _c('strong', [_vm._v("rascunho")]), _vm._v("?\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "retificaModalLabel"
    }
  }, [_vm._v("\n              Retificar Declaração\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('strong', [_vm._v("Atenção")]), _vm._v(" A declaração só pode ser retificada\n                  "), _c('strong', [_vm._v("uma vez")]), _vm._v(". Deseja retificar agora?\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39c2896c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/declaracao/index.vue
// module id = oQj+
// module chunks = 5